__turbopack_context__.v({
  "className": "jetbrains_mono_9c98c9e4-module__p9GMeW__className",
  "variable": "jetbrains_mono_9c98c9e4-module__p9GMeW__variable",
});
